export type Config = {
  environment: string,
  api: {
    apiUrl: string,
    loginApiUrl: string,
    surveyApiUrl: string,
    portalApiUrl: string,
    adminApiUrl: string,
    mlApiUrl: string,
    wsApiUrl: string,
  },
  sentryDSN: string,
  imageSourceUrl: string,
  enableDevTools: boolean,
  enableNewApi: boolean,
}

export const AppConfig = {
  environment: process.env.NODE_ENV,
  api: {
    loginApiUrl: process.env.REACT_APP_LOGIN_API_URL,
    apiUrl: process.env.REACT_APP_API_URL,
    wsApiUrl: process.env.REACT_APP_WS_API_URL ?? process.env.REACT_APP_WS_API_URL,
    // Legacy URLs -- These are irrelevant going forward. Everything in code should go through apiUrl
    mlApiUrl: process.env.REACT_APP_ML_API_URL ?? `${process.env.REACT_APP_API_URL}/api/ml/v1`,
    surveyApiUrl: process.env.REACT_APP_SURVEY_API_URL ?? `${process.env.REACT_APP_API_URL}/api/survey`,
    portalApiUrl: process.env.REACT_APP_PORTAL_API_URL ?? `${process.env.REACT_APP_API_URL}/api/organization`,
    adminApiUrl: process.env.REACT_APP_ADMIN_API_URL ?? `${process.env.REACT_APP_API_URL}/api/support`,
  },
  sentryDSN: process.env.REACT_APP_SENTRY_DSN
} as Config;
